"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecalculateOfferPrice = exports.getIsPriceChanged = void 0;
var _reselect = require("reselect");
var _selectors = require("../../../../../store/selectors");
var _selectors2 = require("../../../../BookingServices/store/selectors");
var getRecalculateOfferPrice = exports.getRecalculateOfferPrice = (0, _reselect.createSelector)([_selectors2.getRecalculatedPriceEntity, function (_, _ref) {
  var currencyCode = _ref.currencyCode;
  return currencyCode;
}], function (recalculatedPrice, currencyCode) {
  if (!recalculatedPrice) {
    return null;
  }
  return recalculatedPrice.price[currencyCode];
});
var getIsPriceChanged = exports.getIsPriceChanged = (0, _reselect.createSelector)([_selectors.getBootstrapOffer, getRecalculateOfferPrice, function (_, _ref2) {
  var currencyCode = _ref2.currencyCode;
  return currencyCode;
}], function (offer, recalculatedPrice, currencyCode) {
  if (recalculatedPrice) {
    var price = offer.price[currencyCode];
    var difference = Math.abs(recalculatedPrice - price);
    var percentageDifference = difference / price * 100;
    return percentageDifference > 1;
  }
  return false;
});